import React from "react";
import AdminSubHeader from "../../../layouts/partials/AdminSubheader";
import MaterialRequestOverview from "../../../shared/materialRequests/MaterialRequestOverview";
import { connect } from "react-redux";
import { selectEvent } from "../../../../redux/preferences/selectors";
import PropTypes from "prop-types";
import { MaterialRequestOverviewNew } from "../../../shared/materialRequests/MaterialRequestOverviewNew";

class MaterialRequests extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static propTypes = {
    event: PropTypes.object
  };

  render() {
    return [
      <AdminSubHeader
        title="Material Requests"
        key="subheader"
        breadcrumbs={[]}
      />,
      <MaterialRequestOverviewNew
        key="content"
        admin
        event={this.props.event}
      />
    ];
  }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = function(state) {
  return {
    event: selectEvent(state)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MaterialRequests);
